import React, { useState, useEffect } from "react";
import { getOneData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";

const SalesReport = () => {
  const [selectedOption, setSelectedOption] = useState("0");
  const [salesData, setSalesData] = useState([]);
  const [salesData2, setSalesData2] = useState([]);
  const [ttl, setTtl] = useState(0);
  const [visibleState, setVisibleState] = useState({
    print: true,
    excel: true,
    sales_code: true,
    customer_no: true,
    from: true,
    to: true,
    sales_report_table_1: true,
    sales_report_table_2: true,
    export1: true,
    export2: true,
  });
  var index = 0;

  useEffect(() => {
    setSalesData([]);
    setSalesData2([]);
    setTtl(0);
    document.getElementById("sales_code").value = "";
    document.getElementById("customer_no").value = "";
    document.getElementById("from").value = "";
    document.getElementById("to").value = "";
    switch (selectedOption) {
      case "0":
        setVisibleState({
          ...visibleState,
          sales_code: true,
          customer_no: true,
          from: true,
          to: true,
          sales_report_table_1: true,
          sales_report_table_2: true,
          export1: true,
          export2: true,
        });
        break;
      case "1":
        setVisibleState({
          ...visibleState,
          sales_code: false,
          customer_no: true,
          from: true,
          to: true,
          sales_report_table_1: false,
          sales_report_table_2: true,
          export1: false,
          export2: true,
        });
        break;
      case "2":
        setVisibleState({
          ...visibleState,
          sales_code: true,
          customer_no: false,
          from: true,
          to: true,
          sales_report_table_1: false,
          sales_report_table_2: true,
          export1: false,
          export2: true,
        });
        break;
      case "3":
        setVisibleState({
          ...visibleState,
          sales_code: true,
          customer_no: true,
          from: false,
          to: false,
          sales_report_table_1: false,
          sales_report_table_2: true,
          export1: false,
          export2: true,
        });
        break;
      case "4":
        setVisibleState({
          ...visibleState,
          sales_code: true,
          customer_no: true,
          from: false,
          to: false,
          sales_report_table_1: true,
          sales_report_table_2: false,
          export1: true,
          export2: false,
        });
        break;

      default:
        setVisibleState({
          ...visibleState,
          sales_code: true,
          customer_no: true,
          from: true,
          to: true,
          sales_report_table_1: true,
          sales_report_table_2: true,
          export1: true,
          export2: true,
        });
        break;
    }
  }, [selectedOption]);

  const fetchReport = (e) => {
    e.preventDefault();
    setSalesData([]);
    setSalesData2([]);
    setTtl([]);
    const frmData = new FormData(document.getElementById("audit_trails_frm"));
    frmData.append("options", selectedOption);
    document.getElementById("spinner").style.display = "block";
    postData(frmData, "fetch_sales")
      .then((data) => {
        // return console.log(data);
        setSalesData(data.report);
        setSalesData2(data.report2);
        setTtl(data.totals);
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  };

  const printPdf = (e) => {
    e.preventDefault();
    var params = "";
    var tbl = "";
    var from = "";
    var to = "";
    switch (selectedOption) {
      case "1":
        const sales_code = document.getElementById("sales_code").value;
        params = `Sales code - (${sales_code})`;
        tbl = document.getElementById("sales_div_1").innerHTML;
        break;
      case "2":
        const customer_no = document.getElementById("customer_no").value;
        params = `Customer No - (${customer_no})`;
        tbl = document.getElementById("sales_div_1").innerHTML;
        break;
      case "3":
        from = document.getElementById("from").value;
        to = document.getElementById("to").value;
        params = `Date - (${from} to ${to})`;
        tbl = document.getElementById("sales_div_1").innerHTML;
        break;
      case "4":
        from = document.getElementById("from").value;
        to = document.getElementById("to").value;
        params = `Date - (${from} to ${to})`;
        tbl = document.getElementById("sales_div_2").innerHTML;
        break;
    }

    let title = "SALES REPORT";

    let j = `
  <div class="row">
  <br><br><br>
  <div class="row">
  <div class="col-md-4" style="font-size:25px;font-weight:bold;text-align:center;">${title}</div>
  <div class="col-md-4" style="font-weight:bold;">${params}</div>
  <br>
  <div class="col-md-4 ml-auto" style="font-weight:bold; text-align: right"></div>
  </div>
  <div>${tbl}</div>  
  </div>
  `;

    var val = htmlToPdfmake(j);
    var dd = {
      pageOrientation: "landscape",
      pageMargins: [10, 60, 40, 60],
      content: val,
      pageSize: "A4",
    };
    pdfMake.createPdf(dd).download();
  };
  return (
    <div>
      <div className=" ml-0">
        <h4 className="fs-title">SALES REPORT</h4>
        <form id="audit_trails_frm" onSubmit={fetchReport}>
          <div className="row">
            <select
              type="text"
              className="form-control-sm col-md-12 mr-2"
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option selected disabled value="0">
                Select Search Option
              </option>
              <option value="1">Sales Code</option>
              <option value="2">Customer No</option>
              <option value="3">Dates</option>
              <option value="4">Items</option>
            </select>
            <input
              hidden={visibleState.sales_code}
              type="text"
              name="sales_code"
              id="sales_code"
              placeholder="Type Sales Code"
              className="form-control col-8 m-1"
            />
            <input
              hidden={visibleState.customer_no}
              type="text"
              name="customer_no"
              id="customer_no"
              placeholder="Type Customer No"
              className="form-control col-8 m-1"
            />
            <label
              htmlFor="from"
              className="col-form-label col-1 m-1"
              hidden={visibleState.from}
            >
              From:
            </label>
            <input
              className="form-control col-3 m-1"
              hidden={visibleState.from}
              type="date"
              name="from"
              id="from"
            />
            <label
              htmlFor="to"
              className="col-form-label col-1 m-1"
              hidden={visibleState.to}
            >
              To:
            </label>
            <input
              className="form-control col-3 m-1"
              type="date"
              name="to"
              id="to"
              hidden={visibleState.to}
            />
            <div className="col-2">
              <button type="submit" className="btn btn-info btn-sm m-1">
                Run
              </button>
            </div>
          </div>
        </form>
      </div>
      <section>
        <div className="row">
          <div className="col-md-12">
            <div className="row" hidden={visibleState.export1}>
              <button
                type="button"
                className="btn btn-sm btn-info col-2"
                onClick={printPdf}
              >
                Print
              </button>
              <ReactHTMLTableToExcel
                className="btn btn-sm btn-success col-2 ml-1"
                id="tbl_1"
                table="tbl1"
                filename="sales_report"
                sheet="sales report"
                buttonText="Export"
                hidden={visibleState.sales_report_table_1}
              />
            </div>
            <form>
              <div
                className="row"
                id="sales_div_1"
                hidden={visibleState.sales_report_table_1}
              >
                <table
                  className="table table-bordered table-sm table-stripped"
                  id="tbl1"
                  style={{ maxHeight: "500px" }}
                >
                  <thead>
                    <tr>
                      <th>Index</th>
                      <th>code</th>
                      <th>Item Name</th>
                      <th>User</th>
                      <th>Customer Phone No</th>
                      <th>Customer Name</th>
                      <th>Mpesa Code</th>
                      <th>Transaction Type</th>
                      <th>Date of Purchase</th>
                      <th>Expiry date</th>
                      <th>Retail Price Per Item</th>
                      <th>Amount per Item</th>
                      <th>Quantity Bought</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salesData.map((dt) => {
                      index++;
                      return (
                        <tr key={dt.id}>
                          <td>{index}</td>
                          <td>{dt.code}</td>
                          <td>{dt.manufacturer_item}</td>
                          <td>{dt.user}</td>
                          <td>{dt.customer_phone_no}</td>
                          <td>{dt.customer_name}</td>
                          <td>{dt.mpesa_code}</td>
                          <td>{dt.type}</td>
                          <td>{dt.date_created}</td>
                          <td>{dt.expiry_date}</td>
                          <td>
                            {dt.retail_price_per_drug
                              ? parseFloat(
                                  dt.retail_price_per_drug
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.transaction_amount
                              ? parseFloat(
                                  dt.transaction_amount
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>{dt.quantity_in_nos}</td>
                          <td>
                            {dt.transaction_total
                              ? parseFloat(
                                  dt.transaction_total
                                ).toLocaleString()
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr style={{ textAlign: "left" }}>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th
                        style={{
                          textAlign: "left",
                          color: "green",
                          fontWeight: "bolder",
                          fontSize: "30px",
                        }}
                      >
                        <span style={{ fontSize: "15px" }}>Total</span>
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          color: "green",
                          fontWeight: "bolder",
                          fontSize: "90px",
                        }}
                      >
                        <span style={{ fontSize: "15px" }}>
                          {ttl ? parseFloat(ttl).toLocaleString() : 0}
                        </span>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="row" hidden={visibleState.export2}>
                <button
                  type="button"
                  className="btn btn-sm btn-info col-2"
                  onClick={printPdf}
                >
                  Print
                </button>
                <ReactHTMLTableToExcel
                  className="btn btn-sm btn-success col-2  ml-2"
                  id="tbl_2"
                  table="tbl2"
                  filename="sales_report"
                  sheet="sales report"
                  buttonText="Export"
                  hidden={visibleState.sales_report_table_2}
                />
              </div>
              <div
                className="row justify-content-center"
                id="sales_div_2"
                hidden={visibleState.sales_report_table_2}
              >
                <table
                  className="table table-bordered table-sm table-stripped"
                  style={{ maxHeight: "500px" }}
                  id="tbl2"
                >
                  <thead>
                    <tr>
                      <th>Index</th>
                      <th>code</th>
                      <th>Item Name</th>
                      <th>Total Quantity</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salesData2.map((dt) => {
                      index++;
                      return (
                        <tr key={dt.item_code}>
                          <td>{index}</td>
                          <td>{dt.item_code}</td>
                          <td>{dt.manufacturer_item}</td>
                          <td>
                            {dt.quantity
                              ? parseFloat(dt.quantity).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.trans_ttl
                              ? parseFloat(dt.trans_ttl).toLocaleString()
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th
                        style={{
                          textAlign: "left",
                          color: "green",
                          fontWeight: "bolder",
                        }}
                      >
                        <span style={{ fontSize: "15px" }}>Total</span>
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          color: "green",
                          fontWeight: "bolder",
                        }}
                      >
                        <span style={{ fontSize: "15px" }}>
                          {ttl ? parseFloat(ttl).toLocaleString() : 0}
                        </span>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </form>
            <Spinner />
          </div>
        </div>
      </section>
    </div>
  );
};

export default SalesReport;
